import { loadFromStorage, lsKeys } from '~features/storage';
import { useCurrentBot } from '~hooks/useCurrentBot';
import { useUserId } from '~hooks/useUserId';
import { useGetPremiumTopicsQuery } from '~services/api/topics';
import type { TTopic } from '~services/api/topics/types';

export const usePremiumTopics = (
	botId: string
): {
	premiumTopics: TTopic[];
	cache: TTopic[];
} => {
	const userId = useUserId();
	const { bot } = useCurrentBot({ recipientId: botId });

	const { data = [] } = useGetPremiumTopicsQuery(
		{ userId, botId },
		{ skip: !bot.clientId }
	);
	const dataFromStorage = loadFromStorage<TTopic[]>(lsKeys.PREMIUM_TOPICS, []);

	return {
		premiumTopics: data,
		cache: dataFromStorage,
	};
};
